var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Store } from 'rxjs-observable-store';
import { UserCertificationService } from '@services/user-certification.service';
import { map } from 'rxjs/operators';
import { CertificationStatus } from '@models/certification-status';
import { CommunicationService } from '@services/communication.service';
import { AuthService } from '@services/auth.service';
import { UserTestService } from '@services/user-test.service';
import * as i0 from "@angular/core";
import * as i1 from "../_services/user-certification.service";
import * as i2 from "../_services/communication.service";
import * as i3 from "../_services/user-test.service";
import * as i4 from "../_services/auth.service";
var DashboardStore = /** @class */ (function (_super) {
    __extends(DashboardStore, _super);
    function DashboardStore(userCertificationService, communicationService, userTestService, authService) {
        var _this = _super.call(this, {
            userCertifications: [],
            communications: [],
            sampleTests: []
        }) || this;
        _this.userCertificationService = userCertificationService;
        _this.communicationService = communicationService;
        _this.userTestService = userTestService;
        _this.authService = authService;
        return _this;
    }
    DashboardStore.prototype.init = function () {
        var _this = this;
        this.userCertificationService.getCerts().subscribe(function (certs) {
            _this.setState(__assign({}, _this.state, { userCertifications: certs }));
        });
        this.userTestService.getSampleTests().subscribe(function (tests) {
            _this.setState(__assign({}, _this.state, { sampleTests: tests }));
        });
        this.communicationService.showUnreadCommunications();
    };
    Object.defineProperty(DashboardStore.prototype, "inactiveCertifications$", {
        get: function () {
            return this.filterCerts(CertificationStatus.Inactive);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardStore.prototype, "activeCertifications$", {
        get: function () {
            return this.filterCerts(CertificationStatus.Active);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardStore.prototype, "pendingCertifications$", {
        get: function () {
            return this.filterCerts(CertificationStatus.Pending);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardStore.prototype, "completedCertifications$", {
        get: function () {
            return this.filterCerts(CertificationStatus.Completed);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardStore.prototype, "expiredCertifications$", {
        get: function () {
            return this.filterCerts(CertificationStatus.Expired);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DashboardStore.prototype, "sampleTests$", {
        get: function () {
            return this.state$.pipe(map(function (state) { return state.sampleTests; }));
        },
        enumerable: true,
        configurable: true
    });
    DashboardStore.prototype.filterCerts = function (by) {
        return this.state$.pipe(map(function (state) { return state.userCertifications.filter(function (cert) { return cert.status === by; }); }));
    };
    DashboardStore.ngInjectableDef = i0.defineInjectable({ factory: function DashboardStore_Factory() { return new DashboardStore(i0.inject(i1.UserCertificationService), i0.inject(i2.CommunicationService), i0.inject(i3.UserTestService), i0.inject(i4.AuthService)); }, token: DashboardStore, providedIn: "root" });
    return DashboardStore;
}(Store));
export { DashboardStore };
